<template>
  <v-app>
    <v-main class="container">
      <header>
        <nuxt-link
          class="logo-link"
          :class="$vuetify.display.name"
          to="/"
        >
          <logo
            width="54"
            height="54"
            class="mr-1"
          />
          <text-logo
            v-if="$vuetify.display.smAndUp"
            class="ml-2"
            width="180"
            height="28"
          />
        </nuxt-link>
        <div class="copyright">
          <div
            v-if="$vuetify.display.smAndUp"
            class="text-body-1 text-beton64"
          >
            <p>Разработано ООО ЦРТ при поддержке</p>
            <p>Федерального агентства по рыболовству</p>
          </div>
          <v-img
            width="54"
            min-width="54"
            height="54"
            class="copyright__logo"
            src="/fish-gov-logo.png"
          />
        </div>
      </header>

      <div
        class="content"
        :class="$vuetify.display.xs && 'px-4'"
      >
        <slot />
      </div>

      <footer>
        <span class="support__text text-blue"> Служба поддержки пользователей: </span>
        <a
          class="support__link text-link"
          rel="nofollow noopener noreferrer"
          :href="`mailto:${supportEmail}`"
        >
          {{ supportEmail }}
        </a>
      </footer>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
const { supportEmail } = useRuntimeConfig().public.app;
</script>

<style lang="scss" scoped>
.container {
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 1fr;
  justify-content: center;
  background-image: url('/waves.svg');
  background-size: cover;
  user-select: none;
}

.content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-link {
  display: flex;
  align-items: center;
}

header {
  margin: 48px 48px 12px;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: space-between;

  @include respond-to(mobile) {
    margin: 24px 24px 12px;
  }

  .copyright {
    display: flex;
    text-align: right;
    align-items: center;

    &__logo {
      margin-left: 8px;
      width: 55px;
      height: 50px;
    }
  }
}

footer {
  margin: 12px 48px 32px;
  text-align: center;

  @include respond-to(mobile) {
    margin: 12px 24px 24px;
  }

  .support__text {
    margin-right: 4px;
  }

  .support__link {
    text-decoration: none;
  }
}
</style>
